import { BrowserRouter, Routes, Route } from "react-router-dom";
import { useEffect } from "react";
import "../assets/css/App.css";
import "../app/modules/EncryptData"; ////use there Login.js
import "./utils/indexedDB"; ////use there Login.js
import { publicRouters, privateRouters } from "./routers";
import { LayoutAdmin } from "./layouts";
import Protected from "./modules/Login/Protected";
import { NetworkProvider, resetToken } from "./contexts/NetworkContext"; ////bien toan cuc online/offline

function App() {
    useEffect(() => {
        const interval = setInterval(() => {
            resetToken();
        }, 60 * 1000); // Kiểm tra mỗi 60 giây

        return () => clearInterval(interval); // cleanup
    }, []);
    return (
        <NetworkProvider>
            <div className="wrapper">
                <BrowserRouter basename={""}>
                    <Routes>
                        {publicRouters.map((route, index) => {
                            const Page = route.component;
                            let Layout = route.layout;
                            return (
                                <Route
                                    exact={true}
                                    key={index}
                                    path={route.path}
                                    element={
                                        <Layout>
                                            <Page />
                                        </Layout>
                                    }
                                />
                            );
                        })}
                        <Route exact path="/" element={<Protected Cmp={LayoutAdmin} />}>
                            {privateRouters.map((route, index) => {
                                const Page = route.component;
                                return <Route exact={true} key={index} path={route.path} element={<Page />} />;
                            })}
                            <Route exact={true} path="*" element={<PageNotFound />} />
                        </Route>
                    </Routes>
                </BrowserRouter>
            </div>
        </NetworkProvider>
    );
}
function PageNotFound() {
    return (
        <div style={{ textAlign: "center", paddingTop: "50px", color: "red" }}>
            <h2>404 - Đường dẫn không tồn tại</h2>
        </div>
    );
}
export default App;
